/* @flow weak */
import * as actions from './actions'
import * as authActions from '../auth/actions'
import { Record } from '../transit'

const State = Record({
  currentLocale: null,
  defaultLocale: null,
  initialNow: null,
  locales: null,
  messages: [],
}, 'intl')

const intlReducer = (state = new State(), action) => {
  switch (action.type) {
    case actions.SET_CURRENT_LOCALE: {
      const { locale } = action.payload
      return state.set('currentLocale', locale)
    }
    case authActions.SIGN_IN_SUCCESS: {
      const { userLanguage } = action.payload.data
      return state.set('currentLocale', userLanguage)
    }

    default:
      return state
  }
}

export default intlReducer



// WEBPACK FOOTER //
// ./src/common/intl/reducer.js